<template>
  <!-- section 1 -->
   <h1 class="self-start text-4xl text-white mt-36 mx-auto px-20 font-semibold ">User Personas</h1>
    <section class=" flexmobile2 mt-32 mx-auto px-20">
      <article class="flex  flex-col">
      <section class="max-md:mr-2.5 mt-4 max-md:max-w-full">
        <div class="flex gap-5 max-md:flex-col">
          <div class="flex  flex-col w-[45%] max-md:ml-0 max-md:w-full">
            <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726664199/Subject_58_bt4nin.png" alt="Steve Roberts" class="object-contain w-full aspect-square max-md:max-w-full" />
          </div>
          <div class="flex flex-col  w-[55%] max-md:ml-0 max-md:w-full">
            <header class="flex flex-col items-center self-stretch my-auto text-3xl font-semibold text-red-300 max-md:mt-10 max-md:max-w-full">
              <h1 class="text-6xl max-md:max-w-full max-md:text-4xl">JULIA CASTILO</h1>
              <p class="mt-5 font-medium text-center text-amber-50 max-md:max-w-full">26, SENIOR DEVELOPER</p>
              <blockquote class="self-stretch dancing-script mt-24 max-md:mt-10 max-md:max-w-full">
                " I'm a fairly busy person with demanding work life and prefer to buy healthy drinks and desserts as I frequently eat from outside."              </blockquote>
            </header>
          </div>
        </div>
      </section>
      <section class="self-end mt-5 mr-0 w-full max-w-[1599px] max-md:max-w-full">
        <div class="flex gap-10 max-md:flex-col">
          <div class="flex  flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex  flex-col grow text-2xl max-md:mt-10 max-md:max-w-full">
              <h2 class="self-start font-bold text-red-300">PAIN POINTS</h2>
              <ol class="mt-5 list-disc text-lg font-medium text-amber-50 max-md:max-w-full">
              <li> Difficulty in browsing food and drinks due to lack of subcategories</li>
              <li>Required to buy extra items to qualify for delivery</li>
              <li>Time consuming payment process as card details cannot be saved</li>
              </ol>
            </div>
          </div>
          <div class="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col text-2xl max-md:mt-10 max-md:max-w-full">
              <h2 class="self-start font-bold text-red-300">GOALS</h2>
              <ul class="mt-5 list-disc text-lg font-medium text-amber-50 max-md:max-w-full">
                <li>Needs allergy free food options which lists all the ingredients</li>
                <li>Enjoys customizing her food</li>
                <li>Needs healthier alternatives to maintain her diet</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </article>
    </section>
    <!-- section 2 -->
    <section class=" flexmobile2 mt-56 mx-auto px-20">
      <article class="flex flex-col">
      <section class="max-md:mr-2.5 max-md:max-w-full">
        <div class="flex gap-5 max-md:flex-col">
          <div class="flex flex-col w-[45%] max-md:ml-0 max-md:w-full">
            <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726664269/3dBoy_kokcbk.png" alt="Steve Roberts" class="object-contain w-full aspect-square max-md:max-w-full" />
          </div>
          <div class="flex flex-col ml-5 w-[55%] max-md:ml-0 max-md:w-full">
            <header class="flex flex-col items-center self-stretch my-auto text-3xl font-semibold text-red-300 max-md:mt-10 max-md:max-w-full">
              <h1 class="text-6xl max-md:max-w-full max-md:text-4xl">STEVE ROBERTS</h1>
              <p class="mt-5 font-medium text-center text-amber-50 max-md:max-w-full">22, FULL-TIME GRADUATE STUDENT</p>
              <blockquote class="self-stretch dancing-script mt-24 max-md:mt-10 max-md:max-w-full">
                " I'm an international student living on a budget. I try to plan my meals for the week. Even though I prefer cooking at home to save money, its not always feasible due to my busy class schedule."
              </blockquote>
            </header>
          </div>
        </div>
      </section>
      <section class="self-end mt-5 mr-0 w-full max-w-[1599px] max-md:max-w-full">
        <div class="flex gap-5 max-md:flex-col">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col grow text-2xl max-md:mt-10 max-md:max-w-full">
              <h2 class="self-start font-bold text-red-300">PAIN POINTS</h2>
              <ol class="mt-5 text-lg list-disc font-medium text-amber-50 max-md:max-w-full">
                <li>Finds its frustrating to wait for several minutes when picking up his food</li>
                <li>Difficulty in understanding certain menu specifications as he is not a native English speaker</li>
              </ol>
            </div>
          </div>
          <div class="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col text-2xl max-md:mt-10 max-md:max-w-full">
              <h2 class="self-start font-bold text-red-300">GOALS</h2>
              <ol class="mt-5 text-lg list-disc font-medium text-amber-50 max-md:max-w-full">
                <li>Find Combo deals and discounts to save money</li>
                <li>Picks up the order to save on delivery charges, but wants to avoid the wait time</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
    </article>
    </section>
    <!-- section 3 -->
    <section class="container flexmobile2 mt-14 mx-auto px-20">
      <div>
        <img loading="lazy" class="animate__animated animate__zoomInRight" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726665657/iPhone_12_Pro_qvenpk.png" alt="">
      </div>
    </section>
    <!-- section 4 -->
     <section class=" flexmobile2 mx-auto px-20 text-lg text-white">
      <h1 class="self-start text-4xl font-semibold text-white">Introducing Celéste French Patisserie App</h1>
      <p class="pt-12 text-lg ">Celéste French patisserie app allows its users to get the best deals and even customize their orders as they please.</p>
      <p class="pt-6 text-lg ">You may order your favorite French delights from the comfort of your home and track them until they arrive at your doorstep as well as monitor the ETA  of the pick-up orders.  </p>
      <p class="pt-6 text-lg ">To further fit the diverse user needs better, the application is equipped with both light and dark mode and voice command features and allows to save card details for a faster ordering experience.</p>
     </section>
     <!-- section 5 video -->
      <section class="container flexmobile2 flex justify-center mt-32 mx-auto px-20 text-xl text-white">
 
      <!-- Video overlay -->
      <video
        class="  h-[650px] object-cover"
        autoplay
        muted
        loop
      >
        <source src="https://res.cloudinary.com/dkdzcp4au/video/upload/v1726666276/bakery_aeldag.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      </section>
      <!-- section 6 -->
       <section class="flexmobile2 mt-28 mx-auto px-20">
        <section class="md:w-full  md:mt-10">
        <h1 class="self-start text-4xl font-semibold text-white">In a nutshell</h1>
        <div class="flex gap-10 flexmobile2 flex-col md:flex-row justify-between">
          <div class="w-full md:w-9/12">
            <section class="flex flex-col rounded-none md:max-w-1/2">
      
      <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6 ml-4 mt-4">User Frustrations</p>
      <ul class=" w-full flexmobile2  text-white max-md:max-w-full ml-8">
        <li class="pt-6 text-lg "> Lack of Subcategories for food and drinks </li>
        <li class="pt-6 text-lg ">Time consuming payment process</li>
        <li class="pt-6 text-lg ">Most apps strain users' eyes by not aligning with phone visual settings</li>
        <li class="pt-6 text-lg ">No intimation about the order status</li>
    </ul>
    </section>
          </div>
          <div class="mobile-hidden">
            <img loading="lazy" class="" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663764/Line_1_3_yea5bl.png" alt="">
          </div>
          <div class="flex flexmobile2 flex-col ml-0 mx-auto container w-full md:w-1/2 mt-10 md:mt-0">
            <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6 mt-4">Implemented Features</p>
      <ul class=" w-full flexmobile2  text-white max-md:max-w-full">
        <li class="pt-6 text-lg "> Added distinct subcategories for easy scanning </li>
        <li class="pt-6 text-lg ">Option to save card details for returning users</li>
        <li class="pt-6 text-lg ">Option to switch between light and dark mode</li>
        <li class="pt-6 text-lg ">User are kept informed at each step from preparation to delivery</li>
    </ul>
          </div>
        </div>
      </section>
       </section>
       <!-- section 7 -->
        <section class="  flexmobile2 mt-28 mx-auto px-20">
        <div class="text-3xl font-semibold text-white">
        <h1 class="self-start text-4xl font-semibold text-white">Sitemap</h1>
        </div>
        <div class=" mt-20">
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726666313/Wireframes_1_bdw07h.png" alt="">
        </div>
        </section>
        <!-- section 8 -->
        <section class="  flexmobile2 mt-28 mx-auto px-20">
          <div class="text-3xl font-semibold text-white">
          <p> </p><h1 class="self-start text-4xl font-semibold text-white">Objectives & Outcomes</h1>
          <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6 ml-4">Personalization</p>
        </div>
        <div class="text-white ml-8">
          <p class="pt-6 text-lg ">Caters to individual preferences, dietary needs, and cultural variations.</p>
          <p class="pt-6 text-lg ">Enhances enjoyment, accommodates allergies, and promotes healthy eating, fostering a sense of inclusivity and satisfaction in diverse dining experiences.</p>
        </div>
        </section>
        <!-- section 9 -->
          <section class=" flexmobile2 mt-28 mx-auto px-20">
          <section class="flex flexmobile2 flex-col rounded-none">
    <header class="self-end flex justify-between mr-64 max-w-full max-md:mr-2.5">
      <div>
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726669888/Group_34197_2_zwfql8.png" alt=""  class="ml-40">
      </div>
    </header>
    <main class="flex flex-col mt-32 ml-4 max-w-full text-3xl w-[1092px] max-md:mt-10">
      <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6">Accessibility Enhancement</p>
      <p class=" pt-6 text-lg md:pb-6 max-md:max-w-full text-white ">
        Microphone input aids those with motor impairments or disabilities preventing traditional inputs.
      </p>
      <!-- <form class="flex flex-wrap gap-5 justify-between py-2.5 pr-5 pl-20 mt-12 mr-5 max-w-full rounded-3xl bg-neutral-100 shadow-[0px_1px_15px_rgba(0,0,0,0.03)] text-neutral-400 w-[716px] max-md:pl-5 max-md:mt-10 max-md:mr-2.5">
        <label for="searchFood" class="sr-only">Search Food</label>
        <input type="text" id="searchFood" placeholder="Search Food" class="my-auto bg-transparent border-none focus:outline-none" />
        <button type="submit" aria-label="Search"> -->
          <div class="ml-80">
          <img loading="lazy" src="https://res.cloudinary.com/dvkj5orhe/image/upload/v1732246590/yuyncwzlqvufsuibpbnx.png" alt="" class="object-contain shrink-0 aspect-square" />
        </div>
        <!-- </button>
      </form> -->
    </main>
          </section>
          <section class="self-end mt-10 w-full  max-md:mt-10 max-md:max-w-full">
    <div class="flex gap-5 max-md:flex-col">
      <div class="flex flex-col w-[55%] max-md:ml-0 max-md:w-full">
        <div class="flex flex-col mt-32 mr-0 max-md:mt-10 max-md:max-w-full">
          <p class="text-lg md:pb-6 text-white  max-md:max-w-full">
            The light/dark mode feature accommodates different visual needs and environments and helps to reduce eye strain, improve readability, and ensure inclusivity, promoting usability for a wider range of users.
          </p>

          <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6 mt-52">Promotion of Deals and Offers</p>
        </div>
      </div>
      <div class="flex flex-col ml-5 w-[56%] max-md:ml-0 max-md:w-full">
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/c2c6de131335366f0be2e136e3331e3a333ec9d9b0ad57d2f0e6fc96d47edf7f?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Visual representation of light/dark mode and promotional deals" class="object-contain grow w-full aspect-[1.33] max-md:max-w-full" />
      </div>
    </div>
          </section>
  <section class="mt-8 w-full max-w-[1516px] max-md:max-w-full">
    <div class="flex gap-5 max-md:flex-col">
      <div class="flex flex-col w-[28%] max-md:ml-0 max-md:w-full">
        <div class="grow max-md:mt-10">
          <div class="flex gap-5 max-md:flex-col">
            <div class="flex flex-col  max-md:ml-0 max-md:w-full">
              <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726836080/Group_34220_zjeydq.png" alt="Promotional offer image" class="object-contain w-full aspect-square" style="scale: 1.2;"/>
            </div>
            
          </div>
        </div>
      </div>
      <div class="flex flex-col ml-5 w-[72%] max-md:ml-0 max-md:w-full mt-16">
        <p class="pt-24 md:pt-16 text-lg  text-white max-md:max-w-full">
          Combo deals and offers are highlighted on the homepage so that it can be easily availed by app users.<br /><br />This helps to amplify food visibility, attract customers, boost sales, and create a sense of value, enticing consumers to explore new culinary experiences while fostering brand loyalty.
        </p>
      </div>
    </div>
  </section>
          </section>
  </template>
  
  <script>
  export default {
    name: 'BakeryAppTwo'
  }
  </script>